import { createContext } from "react";
const collaboratorContext = createContext();
export default collaboratorContext;
